import { MutationHookOptions, useMutation } from '@apollo/client';

import { PUBLISH_AUTOMATION_MUTATION } from '@frontend/app/queries';
import { PublishAutomation, PublishAutomationVariables } from '@frontend/app/queries/types/PublishAutomation';

type IOptions = MutationHookOptions<PublishAutomation, PublishAutomationVariables>;

export const usePublishAutomationMutation = (options: IOptions = {}) =>
  useMutation<PublishAutomation, PublishAutomationVariables>(PUBLISH_AUTOMATION_MUTATION, options);
